var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('PaymentWidgetWithoutStore',{attrs:{"payment":_vm.newPaymentParameters,"assetComponent":_vm.assetComponent,"unitOfMeasure":_vm.assetComponentUnitOfMeasure,"validationErrors":_vm.validationErrors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }